<!-- Modal para visualizar videos - Copiado del videos-config.component -->
<div
  *ngIf="isVisible"
  class="video-visualizer"
  (click)="closeDialog()"
>
  <div class="video-visualizer-content" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="closeDialog()">
      &times;
    </button>

    <!-- Usar nuestro componente reutilizable YouTube Player -->
    <div #youtubePlayer>
      <app-youtube-player
        *ngIf="getVideoId()"
        [videoId]="getVideoId()"
        [params]="getVideoParams()"
      ></app-youtube-player>
    </div>

    <!-- Mensaje de error si no hay video ID -->
    <div *ngIf="!getVideoId()" class="error-message">
      <p>No se pudo extraer el ID del video de YouTube</p>
    </div>
  </div>
</div>
